import { Modal, Button } from 'components-antd';
import { useFormik } from 'formik';
import { QuillEditor } from '../QuillEditor';
import styles from './styles.module.scss';

export type AddDetailsModalProps = {
  open: boolean;
  showModal: (open: boolean) => void;
  initialValue?: string;
  onSave?: (value: string) => void;
};

function DetailsModal({ open, showModal, initialValue = '', onSave }: AddDetailsModalProps) {
  const formik = useFormik({
    initialValues: { details: initialValue },
    onSubmit: (values) => {
      onSave?.(values.details);
      showModal(false);
    },
  });

  return (
    <Modal
      title={
        <span className={styles.headerTitle}>
          <span className={styles.headerText}>Add Details</span>
        </span>
      }
      open={open}
      wrapClassName={styles.addDetailsModal}
      onCancel={() => showModal(false)}
      width={700}
      className={styles.addDetailsModal}
      okText={'Save'}
      okButtonProps={{ disabled: !formik.isValid }}
      onOk={() => formik.handleSubmit()}
    >
      <form onSubmit={formik.handleSubmit}>
        <QuillEditor
          value={formik.values.details}
          onChange={(value) => formik.setFieldValue('details', value)}
          onBlur={() => formik.setFieldTouched('details', true)}
          placeholder="Add details here..."
          className={styles.detailsEditor}
        />
      </form>
    </Modal>
  );
}

export default DetailsModal;
